// utilitário genérico para baixar blobs vindos do axios mantendo headers de auth
export function extractFilenameFromDisposition(disposition?: string): string | null {
  if (!disposition) return null;
  // exemplos: attachment; filename="ordem-servico-10.pdf"
  //           attachment; filename=device-reports-10.pdf
  const filenameMatch = /filename\*?=(?:UTF-8''|")?([^\";]+)/i.exec(disposition);
  if (!filenameMatch) return null;

  try {
    // trata nomes com % (RFC5987) ou com aspas
    const raw = decodeURIComponent(filenameMatch[1]).replace(/\"/g, '');
    return raw;
  } catch {
    return filenameMatch[1].replace(/\"/g, '');
  }
}

export function triggerBrowserDownload(data: Blob, filename: string) {
  const url = URL.createObjectURL(data);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
